import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function SupportMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M10.464 21.36h3.072c.744 0 1.32-.504 1.44-1.2 1.992-.936 3.408-2.688 3.864-4.8h.384c1.752 0 3.096-1.344 3.096-3.096v-1.008c0-1.752-1.344-3.096-3.096-3.096h-.384c-.648-3.12-3.432-5.52-6.84-5.52s-6.192 2.4-6.84 5.52h-.384c-1.752 0-3.096 1.344-3.096 3.096v1.008c0 1.752 1.344 3.096 3.096 3.096h2.16V9.552C6.936 6.744 9.192 4.44 12 4.44c2.808 0 5.064 2.304 5.064 5.112v4.368c0 1.704-.84 3.216-2.112 4.152-.192-.624-.72-1.032-1.416-1.032h-3.072c-.84 0-1.464.624-1.464 1.464v1.392c0 .84.624 1.464 1.464 1.464zM3.36 12.264v-1.008c0-1.056.36-1.416 1.416-1.416h.24v3.84h-.24c-1.056 0-1.416-.36-1.416-1.416zm7.2 7.488v-1.104c0-.024.024-.048.048-.048h2.784c.024 0 .048.024.048.048v1.104a.052.052 0 01-.048.048h-2.784a.052.052 0 01-.048-.048zm8.424-6.072V9.84h.24c1.056 0 1.416.36 1.416 1.416v1.008c0 1.056-.36 1.416-1.416 1.416h-.24z"  /></Svg>;
}
export default SupportMedium;